if (!customElements.get('quiz-results')) {
  class QuizResults extends CustomElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.embedPage();
    }

    async embedPage() {
      const page = this.getAttribute('page');
      const res = await fetch(`/pages/${page}`);

      if (res.status !== 200) {
        console.error(
          '[QUIZ RESULTS] Failed to load results page %s (%s)',
          page,
          res.status,
        );
        return;
      }

      /** @type {HTMLElement|null} */
      const containerEl = this.closest('section.app-section');

      if (!containerEl) {
        throw new Error('[QUIZ REUSLTS] Could not find container element');
      }

      containerEl.classList.add('quiz-app-section', 'is-loading');

      const html = await res.text();
      const children = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('main');

      if (!children) {
        return;
      }

      const scriptTags = children.querySelectorAll('script');

      containerEl.innerHTML = children.innerHTML;
      this.injectScriptTags(scriptTags);

      containerEl.classList.add('is-loading-out');

      window.setTimeout(() => {
        containerEl.classList.remove('is-loading-out', 'is-loading');
      }, 360);

      console.log(
        '%c[QUIZ RESULTS] Injected page %s',
        'color: orange; font-weight:bold',
        page,
      );
    }

    /**
     * @param {NodeListOf<HTMLScriptElement>} tags
     */
    injectScriptTags(tags) {
      const sources = [...tags].map(tag => tag.src).filter(Boolean);
      const uniqueSources = [...new Set(sources)];
      for (const src of uniqueSources) {
        const script = document.createElement('script');
        script.src = src;
        script.defer = true;
        document.body.appendChild(script);
      }
    }
  }

  customElements.define('quiz-results', QuizResults);
}
